import { useEffect, useState } from 'react'
import { type CrossClientQueryResult } from '../../../../models/CrossClient'

interface ResolvedResults {
  results: CrossClientQueryResult[] | null
  resolving: boolean
}

export const useResolvedResults = (resolveResults: () => Promise<CrossClientQueryResult[]>): ResolvedResults => {
  const [results, setResults] = useState<CrossClientQueryResult[] | null>(null)

  useEffect(() => {
    let alive = true
    resolveResults()
      .then((resolved) => {
        if (alive) {
          setResults(resolved)
        }
      })
      .catch(() => {
        if (alive) {
          setResults([])
        }
      })
    return () => {
      alive = false
    }
  }, [resolveResults])

  return { results, resolving: results === null }
}
